export const UPDATE_POSTCODE = 'src/Address/UPDATE_POSTCODE'

export const REQUEST_ADDRESS = 'src/Address/REQUEST_ADDRESS'
export const REQUEST_ADDRESS_SUCCESS = 'src/Address/REQUEST_ADDRESS_SUCCESS'
export const REQUEST_ADDRESS_FAILED = 'src/Address/REQUEST_ADDRESS_FAILED'

export const SELECT_ADDRESS = 'src/Address/SELECT_ADDRESS'

export const REQUEST_ADDRESS_REL = 'SearchAddressByPostCode'
